import { render, staticRenderFns } from "./SecondsDisplay.vue?vue&type=template&id=3745c267&scoped=true&"
import script from "./SecondsDisplay.vue?vue&type=script&lang=js&"
export * from "./SecondsDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3745c267",
  null
  
)

export default component.exports